import React, { useState } from 'react';
import { InputComponent } from '../custcomponents';
import { AxiosInstance } from '../utils';
import { useNavigate } from "react-router-dom";

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { toast } from 'react-toastify';

const LoginScreen = ({ auth, loginHandler }: any) => {

    // State to hold username, password, and error message
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // Handle form submission
    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const username: any = formData.get("username");
        const password: any = formData.get("password");
        // Basic validation
        if (!username || !password) {
            setError('Both fields are required!');
            return;
        }
        signInWithEmailAndPassword(auth, username, password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                console.log(user);

                sessionStorage.setItem('TOKEN_KEY', (user as any).accessToken);
                navigate('/weba');
                loginHandler(true);
                // ...
            })
            .catch((error) => {
                toast.error("Login Failed.");
                console.log(error);
            });


    }

    return (

        <section className="about-sec sec-padding" id="about" data-scroll-index="1">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                    </div>
                    <div className="col-lg-6">
                        <div className="sec-title">
                            <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-star fa-stack-1x"></i></span></span>
                            <h3 className="wow fadeInRight" data-wow-duration="500ms">ADMIN LOGIN</h3>
                        </div> {/* <!--sec-title end--> */}
                    </div> </div>
                <div className="about-sec-details">
                    <div className="row">
                        <div className="col-lg-4">
                        </div>
                        <div className="col-lg-6">

                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <InputComponent custname="username" custid="txtusername" custplaceholder="username" />
                                        <InputComponent type="password" custname="password" custid="txtpassword" custplaceholder="Password" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="form-field text-center mgt-40 wow fadeInUp" data-wow-duration="300ms">
                                            <button type="submit" disabled={loading} className="btn-default">LOGIN {loading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div> {/* <!-- about-sec-details end--> */}
            </div>
        </section>
    );
};

export default LoginScreen;
